export default function W7SCloudLink({
  className = "text-amber-400 hover:text-amber-300 underline underline-offset-4",
}) {
  return (
    <a
      href="https://w7s.cloud/"
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      w7s.cloud
    </a>
  );
}
